"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDismissalMethods = void 0;
const lodash_1 = require("lodash");
const getDismissalMethods = (props) => {
    let dismissalMethods = [
        {
            id: 'CAUGHT',
            name: 'Caught',
            abbrev: 'c',
            fielders: true,
            crossed: true,
            allowedWithRuns: false,
            allowedWithWides: false,
            allowedWithNoBalls: false,
        },
        {
            id: 'LBW',
            name: 'LBW',
            abbrev: 'lbw',
            fielders: false,
            crossed: false,
            allowedWithRuns: false,
            allowedWithWides: false,
            allowedWithNoBalls: false,
        },
        {
            id: 'BOWLED',
            name: 'Bowled',
            abbrev: 'b',
            fielders: false,
            crossed: false,
            allowedWithRuns: false,
            allowedWithWides: false,
            allowedWithNoBalls: false,
        },
        {
            id: 'STUMPED',
            name: 'Stumped',
            abbrev: 'st',
            fielders: true,
            crossed: false,
            allowedWithRuns: false,
            allowedWithWides: true,
            allowedWithNoBalls: false,
        },
        {
            id: 'RUN_OUT',
            name: 'Run Out',
            abbrev: 'ro',
            fielders: true,
            crossed: true,
            allowedWithRuns: true,
            allowedWithWides: true,
            allowedWithNoBalls: true,
        },
        {
            id: 'HIT_WICKET',
            name: 'Hit wicket',
            abbrev: 'hw',
            fielders: false,
            crossed: false,
            allowedWithRuns: false,
            allowedWithWides: true,
            allowedWithNoBalls: false,
        },
        {
            id: 'HIT_TWICE',
            name: 'Hit ball twice',
            abbrev: 'ht',
            fielders: false,
            crossed: false,
            allowedWithRuns: false,
            allowedWithWides: false,
            allowedWithNoBalls: true,
        },
        {
            id: 'TIMED_OUT',
            name: 'Timed out',
            abbrev: 'to',
            fielders: false,
            crossed: false,
            allowedWithRuns: false,
            allowedWithWides: false,
            allowedWithNoBalls: false,
        },
        {
            id: 'OBSTRUCTING_FIELD',
            name: 'Obstructing the field',
            abbrev: 'of',
            fielders: false,
            crossed: true,
            allowedWithRuns: true,
            allowedWithWides: true,
            allowedWithNoBalls: true,
        },
        {
            id: 'RETIRED',
            name: 'Retired',
            abbrev: 'rt',
            fielders: false,
            crossed: true,
            allowedWithRuns: true,
            allowedWithWides: true,
            allowedWithNoBalls: true,
        },
        {
            id: 'HANDLED_BALL',
            name: 'Handled ball',
            abbrev: 'hb',
            fielders: false,
            crossed: false,
            allowedWithRuns: false,
            allowedWithWides: false,
            allowedWithNoBalls: false,
        },
        {
            id: 'ABSENT',
            name: 'Absent',
            abbrev: 'abs',
            fielders: false,
            crossed: false,
            allowedWithRuns: false,
            allowedWithWides: false,
            allowedWithNoBalls: false,
        },
    ];
    if (props.runs || props.isNonStrikeBatter) {
        dismissalMethods = (0, lodash_1.filter)(dismissalMethods, { allowedWithRuns: true });
    }
    if (props.wides) {
        dismissalMethods = (0, lodash_1.filter)(dismissalMethods, { allowedWithWides: true });
    }
    else if (props.noBalls) {
        dismissalMethods = (0, lodash_1.filter)(dismissalMethods, { allowedWithNoBalls: true });
    }
    return dismissalMethods;
};
exports.getDismissalMethods = getDismissalMethods;
//# sourceMappingURL=getDismissalMethods.js.map